export const QR_LIFETIME_MS = 20000;

export function readQrSession(session, whatsappId, companyId, now = Date.now()) {
  if (!session || String(session.id) !== String(whatsappId) ||
      String(session.companyId) !== String(companyId)) return null;
  const generatedAt = Date.parse(session.updatedAt);
  const expiresAt = generatedAt + QR_LIFETIME_MS;
  const valid = session.status === "qrcode" && typeof session.qrcode === "string" &&
    session.qrcode.length > 0 && Number.isFinite(generatedAt) && expiresAt > now;
  return {
    code: valid ? session.qrcode : "",
    expiresAt: valid ? expiresAt : 0,
    connected: session.status === "CONNECTED"
  };
}
